// Synchronous barrier: a call cannot start between the idle check and the
// updater's async confirmation/install. No media or encryption data crosses it.
const blockers = new Set<() => boolean>();
let installing = false;
let pendingOperations = 0;

/** Synchronous, nestable barrier across encryption, upload and message sends. */
export function beginUpdateActivity(): () => void {
  pendingOperations++;
  let finished = false;
  return () => { if (!finished) { finished = true; pendingOperations--; } };
}

export function registerUpdateBlocker(blocker: () => boolean): () => void {
  blockers.add(blocker);
  return () => { blockers.delete(blocker); };
}

export function updateIsBlocked(): boolean {
  return installing || pendingOperations > 0 || [...blockers].some(blocker => blocker());
}

export function assertUpdateNotInstalling(): void {
  if (installing) throw new Error("Link is preparing an update. Cancel the update or wait for Link to reopen before calling.");
}

export async function withUpdateInstall<T>(install: () => Promise<T>): Promise<T> {
  if (updateIsBlocked()) throw new Error("Finish your current call before restarting Link to update.");
  installing = true;
  try { return await install(); }
  finally { installing = false; }
}
